import React from 'react';

function DBAIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="24"
            viewBox="0 0 20 24"
            fill="none"
        >
            <path
                d="M10 0C5.27894 0 0.5 1.15392 0.5 3.36V3.40992C1.93949 4.92192 5.22376 5.76 10 5.76C14.7762 5.76 18.0605 4.92192 19.5 3.40992V3.36C19.5 1.15392 14.7211 0 10 0ZM0.5 16.2211V20.64C0.5 22.8461 5.27894 24 10 24C14.7211 24 19.5 22.8461 19.5 20.64V16.2211C17.9357 17.351 15.0956 18.24 10 18.24C4.9044 18.24 2.06434 17.351 0.5 16.2211ZM0.5 4.70114V9.16992C1.93949 10.6819 5.22376 11.52 10 11.52C14.7762 11.52 18.0605 10.6819 19.5 9.16992V4.70114C17.9357 5.83106 15.0956 6.72 10 6.72C4.9044 6.72 2.06434 5.83106 0.5 4.70114ZM10 12.48C15.0956 12.48 17.9357 11.5911 19.5 10.4611V14.9299C18.0605 16.4419 14.7762 17.28 10 17.28C5.22376 17.28 1.93949 16.4419 0.5 14.9299V10.4611C2.06434 11.5911 4.9044 12.48 10 12.48Z"
                fill="url(#paint0_linear_829_589)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_829_589"
                    x1="10"
                    y1="0"
                    x2="10"
                    y2="24"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF8F05" />
                    <stop offset="1" stopColor="#FF682F" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default DBAIcon;
